import axios from 'axios';
import {
  SYSTEM_TOAST_ERROR_MESSAGE,
  SYSTEM_TOAST_SUCCESS_MESSAGE,
  SYSTEM_TOAST_WARNING_MESSAGE,
  SYSTEM_TOAST_INFO_MESSAGE,
  SYSTEM_TOAST_CLEAR,
  SYSTEM_LINKS_MAIS_MANSERV
} from '../actions/types';
import { serverEndPoint } from './Utils';

export const openToast = (message, toastType = 'error') => {
  const type =
    {
      success: SYSTEM_TOAST_SUCCESS_MESSAGE,
      info: SYSTEM_TOAST_INFO_MESSAGE,
      warning: SYSTEM_TOAST_WARNING_MESSAGE,
    }[toastType] || SYSTEM_TOAST_ERROR_MESSAGE;

  return async (dispatch) => {
    dispatch({
      type: type,
      payload: message,
    });
  };
};

export const clearToast = () => {
  return async (dispatch) => {
    dispatch({
      type: SYSTEM_TOAST_CLEAR,
    });
  };
};
export const setLinkMaisMaerv = (URL) => {
  return async (dispatch) => {
    dispatch({
      type: SYSTEM_LINKS_MAIS_MANSERV,
      payload: URL
    });
  };
};

export const getLink = async () => {

  try {
    const { data } = await axios.get(`${serverEndPoint}/user/getIdsMaisManserv`);

    return data;

  } catch (error) {
    console.log(error);
  }

};